import { render, staticRenderFns } from "./CustomFieldPreview.vue?vue&type=template&id=462454ff&scoped=true&"
import script from "./CustomFieldPreview.vue?vue&type=script&lang=js&"
export * from "./CustomFieldPreview.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldPreview.vue?vue&type=style&index=0&id=462454ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462454ff",
  null
  
)

export default component.exports